export const BAIT_BOX_ACTIONS = {
  TAGS: 'assign-tag',
  COMMENTS: 'comments',
  LOGS: 'logs',
};
